/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIContractFile
 */
export interface APIContractFile {
    /**
     * 
     * @type {string}
     * @memberof APIContractFile
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIContractFile
     */
    contract: string;
    /**
     * 
     * @type {string}
     * @memberof APIContractFile
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContractFile
     */
    document?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIContractFile
     */
    readonly name: string;
    /**
     * 
     * @type {Date}
     * @memberof APIContractFile
     */
    readonly storedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIContractFile
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof APIContractFile
     */
    readonly size: number;
}

/**
 * Check if a given object implements the APIContractFile interface.
 */
export function instanceOfAPIContractFile(value: object): value is APIContractFile {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('contract' in value) || value['contract'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('storedAt' in value) || value['storedAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function APIContractFileFromJSON(json: any): APIContractFile {
    return APIContractFileFromJSONTyped(json, false);
}

export function APIContractFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContractFile {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'contract': json['contract'],
        'key': json['key'] == null ? undefined : json['key'],
        'document': json['document'] == null ? undefined : json['document'],
        'name': json['name'],
        'storedAt': (new Date(json['stored_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'size': json['size'],
    };
}

export function APIContractFileToJSON(value?: Omit<APIContractFile, 'self'|'name'|'stored_at'|'last_modified_at'|'size'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contract': value['contract'],
        'key': value['key'],
        'document': value['document'],
    };
}

